export default __webpack_public_path__ + "media/track-action.a4efe867.png";